import { render, staticRenderFns } from "./CrewPositionList.vue?vue&type=template&id=50a24ef2&scoped=true"
import script from "./CrewPositionList.vue?vue&type=script&lang=js"
export * from "./CrewPositionList.vue?vue&type=script&lang=js"
import style0 from "./CrewPositionList.vue?vue&type=style&index=0&id=50a24ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a24ef2",
  null
  
)

export default component.exports